type WithholdingTaxAllocation = {
  commitmentId: string;
  totalCommitmentLcy: number;
  withholdingTaxExempt: boolean;
  investorName: string;
};

const getInvestorsWithholdingTax = (
  withholdingTaxList: Array<WithholdingTaxAllocation>,
) => withholdingTaxList.filter((investor) => !investor.withholdingTaxExempt);

export default getInvestorsWithholdingTax;
